export const LOCALES = [
  { code: "es", label: "Español", flag: "ES" },
  { code: "en", label: "English", flag: "EN" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "pl", label: "Polski", flag: "PL" },
  { code: "ro", label: "Română", flag: "RO" },
  { code: "sv", label: "Svenska", flag: "SV" },
  { code: "da", label: "Dansk", flag: "DA" },
  { code: "no", label: "Norsk", flag: "NO" },
];

export const DEFAULT_LOCALE = "es";
export const LOCALE_CODES = LOCALES.map((l) => l.code);
export const SITE_URL = "https://centauros.app";
